import { useEffect, useState } from "react";

/** Gallery-only stand-in for vault / pre-quote fetch on funding & payout pickers. */
export const GALLERY_PICKER_LOADING_MS = 1000;

/**
 * While `open` is true, stay in the shimmer state for `delayMs`, then reveal
 * the list. Re-opening the popup restarts the delay.
 */
export const useGalleryPickerLoading = (
  open: boolean,
  delayMs = GALLERY_PICKER_LOADING_MS
): boolean => {
  const [loading, setLoading] = useState(open);

  useEffect(() => {
    if (!open) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const id = window.setTimeout(() => setLoading(false), delayMs);
    return () => window.clearTimeout(id);
  }, [open, delayMs]);

  return loading;
};
